import type { CSSProperties } from "react";

import { List } from "react-virtualized";

import { KeywordListComposerKeyword } from "./KeywordListComposerKeyword";
import { trackPopupClick } from "./tracking";
import type { Keyword } from "./types";

interface KeywordListComposerKeywordListProps {
    width: number;
    height: number;
    query: string;
    keywords: Keyword[];
    onSelectKeyword: (keywords: Keyword[], isSelected: boolean) => void;
    onDeleteKeyword: (keywords: Keyword[]) => void;
}

export const KeywordListComposerKeywordList = ({
    width,
    height,
    query,
    keywords,
    onSelectKeyword,
    onDeleteKeyword,
}: KeywordListComposerKeywordListProps) => {
    const handleKeywordSelect = (keyword: Keyword) => {
        const nextIsSelected = !keyword.selected;
        onSelectKeyword([keyword], nextIsSelected);
        trackPopupClick({ event: nextIsSelected ? "check" : "uncheck", count: 1 });
    };

    const handleKeywordDelete = (keyword: Keyword) => {
        onDeleteKeyword([keyword]);
        trackPopupClick({ event: "delete", count: 1 });
    };

    const renderRow = ({ index, style }: { index: number; style: CSSProperties }) => {
        const keyword = keywords[index];
        return (
            <KeywordListComposerKeyword
                style={style}
                key={keyword.term}
                keyword={keyword}
                query={query}
                onSelectKeyword={handleKeywordSelect}
                onDeleteKeyword={handleKeywordDelete}
            />
        );
    };

    return (
        <List
            width={width}
            height={height}
            rowCount={keywords.length}
            rowHeight={KeywordListComposerKeyword.height}
            rowRenderer={renderRow}
        />
    );
};
